import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const FutureCourses = lazyRouteComponent(() => import('@/_instructor/past-future-course'));

export const Route = createFileRoute('/_instructor/my-courses/future')({
  component: () => renderInstructorPage(FutureCourses),
});
